/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringstartsaspect8Inputs */

const de__class_stringstartsaspect8 = /** @type {(inputs: _Class_Stringstartsaspect8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`startet mit`)
};

/**

* @param {_Class_Stringstartsaspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringstartsaspect8 = /** @type {((inputs?: _Class_Stringstartsaspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringstartsaspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringstartsaspect8(inputs)
});
export { _class_stringstartsaspect8 as "_class_StringSTARTSAspect" }